const iterationLimit = 10000;
/**
 * Calculate APRC
 * @param amount {Number}
 * @param period {Number}
 * @param monthlyPayment {Number}
 * @param conclusionFee {Number}
 * @returns {Number}
 * @throws Error
 */
const calculateAprc = (amount, period, monthlyPayment, conclusionFee) => {
  const precision = 10E-6;
  let aprcCurrent = 0;
  let aprcNext = 0.25;
  let iterationCounter = 0;


  while (Math.abs(aprcCurrent - aprcNext) > precision) {
    iterationCounter += 1;

    if (iterationCounter >= iterationLimit) {
      throw new Error('APRC calculation takes too many iterations.');
    }

    aprcCurrent = aprcNext;
    let sum = conclusionFee - amount;
    let derivativeSum = sum;

    for (let i = 1; i <= period; i += 1) {
      sum += monthlyPayment * ((1 + aprcCurrent) ** (-i / 12));
      derivativeSum += monthlyPayment * (-i / 12) / ((1 + aprcCurrent) ** (i / 12 + 1));
    }

    aprcNext = aprcCurrent - (sum / derivativeSum);
  }

  if (isNaN(aprcNext)) {
    throw new Error('APRC calculation for those inputs is not mathematically possible with the current algorithm.');
  }

  return Number((aprcNext * 100).toFixed(2));
};
/**
 * Calculate Monthly Payment
 * @param amount {Number}
 * @param period {Number}
 * @param interest {Number}
 * @param maxMaintenanceFee {Number}
 * @param maintenanceFeeRate {Number}
 * @returns {Number}
 */
const calculateMonthlyPayment = (amount, period, interest, maxMaintenanceFee, maintenanceFeeRate) => {
  let maintenanceFee = (amount * maintenanceFeeRate) / 100;
  if (maintenanceFee > maxMaintenanceFee) maintenanceFee = maxMaintenanceFee;
  const modifiedInterest = interest / 1200;
  const loanAmount = modifiedInterest * -amount * ((1 + modifiedInterest) ** period)
      / (1 - ((1 + modifiedInterest) ** period));
  return Number((loanAmount + maintenanceFee));
};

module.exports = { calculateAprc, calculateMonthlyPayment };
